// extracted by mini-css-extract-plugin
export default {"logos":"Accreditations_logos__gqxyM","logo":"Accreditations_logo__0uMda","image":"Accreditations_image__OCIYl","middle":"Accreditations_middle__-LYax"};